// src/utils/reducerHelpers.js
import { showSuccessToast, showErrorToast } from "./toastUtils";

export const handleApiResponse = (
  state,
  action,
  {
    endpoint = "",
    successMessage = "",
    dataKey = null,
    resetKeys = [],
    toastSuccess = true,
    toastError = true,
    defaultFailMessage = "Request failed",    // alias `failMessage` for callers that use that name
    failMessage,
    successStatuses = [200, 201],
    customErrors = {},
    onSuccess, // optional callback: (state, payloadData, fullResponse) => void
  } = {}
) => {
  // allow alias
  if (failMessage) defaultFailMessage = failMessage;

  const response = action.payload || {};
  const status = response.status;
  const id = response.id;

  let payloadData;
  if (response && Object.prototype.hasOwnProperty.call(response, "data")) {
    payloadData = response.data;
  } else {
    const { status: _s, id: _i, ...rest } = response;
    payloadData = Object.keys(rest).length ? rest : undefined;
  }

  state.endPoint = endpoint;
  state.isLoading = false;

  const errorMessages = {
    400: "Bad Request: Invalid data provided",
    401: "Unauthorized: Please authenticate",
    403: "Forbidden: You do not have permission to perform this action",
    404: "Not Found: Resource missing",
    500: "Internal Server Error: Something went wrong",
    ...customErrors,
  };

  if (successStatuses.includes(status)) {
    state.success = true;
    state.message = successMessage || "";
    if (toastSuccess && successMessage) showSuccessToast(state.message);

    if (dataKey) {
      if (id !== undefined) {
        state[dataKey] = { ...(state[dataKey] || {}), [id]: payloadData };
      } else if (payloadData !== undefined) {
        state[dataKey] = { ...(state[dataKey] || {}), ...payloadData };
      }
    }

    resetKeys.forEach((k) => {
      state[k] = {};
    });

    if (typeof onSuccess === "function") {
      try {
        onSuccess(state, payloadData, response);
      } catch (err) {
      }
    }
  } else {
    state.success = false;
    state.message = errorMessages[status] || defaultFailMessage;
    if (toastError) showErrorToast(state.message);
  }
};
